import { Box, Typography } from '@mui/material';

export const storeCardOuterGradient = 'linear-gradient(to top, #822AFF 0%, #FF00F2 41.566%)';
export const rapCoinHeaderGradient =
  'radial-gradient(circle at 50% 50%, rgba(153,46,0,1) 63.46%, rgba(102,31,0,1) 100%)';
export const rapGemHeaderGradient =
  'radial-gradient(circle at 50% 50%, rgba(78,25,153,1) 63.46%, rgba(52,17,103,1) 100%)';
export const vipRoomHeaderGradient =
  'radial-gradient(circle at 50% 50%, rgba(36,33,40,1) 63.46%, rgba(19,18,22,1) 81.73%, rgba(11,10,12,1) 90.87%, rgba(3,3,3,1) 100%)';

/** Figma 8709:18754 — RapCoin footer shows price only; other store tabs keep Buy prefix */
export function StorePriceFooter({ price, originalPrice, showBuyPrefix = true }) {
  const priceLabel = `${price}`;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        pb: { xs: 0.5, md: 0.75 },
        pt: { xs: '4px', md: '4px' },
      }}
    >
      <Typography
        sx={{
          color: '#fff',
          fontWeight: 600,
          fontSize: { xs: 16, md: 16 },
          lineHeight: { xs: '24px', md: '24px' },
          letterSpacing: '0.8px',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          px: 0.25,
        }}
      >
        {priceLabel}
      </Typography>
      {originalPrice ? (
        <Typography
          sx={{
            color: '#fff',
            fontWeight: 400,
            fontSize: { xs: 14, md: 14 },
            lineHeight: 'normal',
            letterSpacing: '0.8px',
            opacity: 0.7,
            textDecoration: 'line-through',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
        >
          {originalPrice}
        </Typography>
      ) : null}
    </Box>
  );
}

export default function StoreCardShell({ headerGradient, onClick, footer, children }) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '100%',
        aspectRatio: { xs: '1 / 1', md: '1 / 1' },
        borderRadius: '22px',
        background: storeCardOuterGradient,
        cursor: 'pointer',
        overflow: 'hidden',
        boxShadow: '0 8px 18px #00000066',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '2px',
          left: '2px',
          right: '2px',
          height: '70%',
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          background: headerGradient,
          boxShadow: 'inset 0 12px 10px rgba(43,0,118,0.39)',
          pointerEvents: 'none',
        }}
      />

      {children}
      {footer}
    </Box>
  );
}
